const PanoramaMockData = {
  resourceURL: 'https://xsdj-vr-oss-test.myscrm.cn/h5-projects/vr-res-1592050663540527104/1592050911545528320',
  // krpano的配置
  panoConfigURL:
    'https://xsdj-vr-oss-test.myscrm.cn/h5-projects/vr-res-1592050663540527104/1592050911545528320/vr/config/module_1657519538738.json',
  // 项目的配置
  projectConfigURL: `https://xsdj-vr-oss-test.myscrm.cn/h5-projects/vr-res-1592050663540527104/1592050911545528320/vr/config/module_1657519538738.json?t=${Date.now()}`,
  xmlName:
    'https://xsdj-vr-oss-test.myscrm.cn/h5-projects/vr-res-1592050663540527104/1592050911545528320/vr/module_1657519538738/tour.xml',
};

export default PanoramaMockData;
